import * as actionTypes from './actionTypes';
import axiosInstance from '../../axios-instance';

export const managementCompanySuccess = payload => {
  return {
    type: actionTypes.MANAGEMENT_COMPANIES_SUCCESS,
    payload: payload
  };
};

export const managementCompanyStart = () => {
  return {
    type: actionTypes.MANAGEMENT_COMPANIES_START
  };
};

export const managementCompanyFail = error => {
  return {
    type: actionTypes.MANAGEMENT_COMPANIES_FAIL,
    error: error
  };
};
export const getManagementCompaniesList = (getData, hideLoader) => {
  return dispatch => {
    if (!(hideLoader !== undefined && hideLoader === true)) {
      //dispatch(managementCompanyStart());
    }
    axiosInstance()
      .get('/management-companies.json', { params: getData })
      .then(response => {
        dispatch(managementCompanySuccess({ ...response.data, loaded: true }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(managementCompanyFail(err.response.data.message));
        } else {
          dispatch(managementCompanyFail('Problem with connection to API.'));
        }
      });
  };
};

export const createManagementCompany = (postData, history) => {
  return dispatch => {
    dispatch(managementCompanyStart());
    axiosInstance()
      .post('/management-companies.json', postData)
      .then(response => {
        history.push('/management-companies/' + response.data.id);
        dispatch(managementCompanySuccess({ list: [], loaded: false }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(managementCompanyFail(err.response.data.message));
        } else {
          dispatch(managementCompanyFail('Problem with connection to API.'));
        }
      });
  };
};

export const editManagementCompany = (entityId, postData, callback) => {
  return dispatch => {
    dispatch(managementCompanyStart());
    axiosInstance()
      .put(`/management-companies/${entityId}.json`, postData)
      .then(response => {
        dispatch(managementCompanySuccess({ viewItem: response.data }));
        dispatch(managementCompanySuccess({ list: [], loaded: false }));
        callback();
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(managementCompanyFail(err.response.data.message));
        } else {
          dispatch(managementCompanyFail('Problem with connection to API.'));
        }
      });
  };
};

export const getManagementCompany = entityId => {
  return dispatch => {
    //dispatch(loaderStart());
    axiosInstance()
      .get('/management-companies/' + entityId + '.json')
      .then(response => {
        dispatch(managementCompanySuccess({ viewItem: response.data }));
        //dispatch(loaderStop());
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(managementCompanyFail(err.response.data.message));
        } else {
          dispatch(managementCompanyFail('Problem with connection to API.'));
        }
        //dispatch(loaderStop());
      });
  };
};
